import httpInstance from '../../httpInstance';

const createAlliesService = async (dataParam) => {
  let res;
  const endpoint = '/referrals/v1/promos/2';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createAlliesService;
